<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group [title]="'wbo.supplier.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name">
                            </wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control
                                formControlName="discontinued"  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="code" [(ngModel)]="model.data.code">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-date-edit-control formControlName="startDate" [(ngModel)]="model.data.startDate">
                        </wbo-date-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="status" [(ngModel)]="model.data.status">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="telephone1" [(ngModel)]="model.data.telephone1">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="telephone2" [(ngModel)]="model.data.telephone2">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="email" [(ngModel)]="model.data.email">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="fax" [(ngModel)]="model.data.fax">
                        </wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="rebatePercent" [(ngModel)]="model.data.rebatePercent" [digitInfo]="'1.0-2'"></wbo-numeric-edit-control>
                    </fui-column>
                    <fui-column *ngIf="Config.VENDORS_GENERATE_PURCHASE_ORDER_CSV | booleanConfig">
                        <wbo-checkbox-edit-control formControlName="generateCsv"
                                                   [(ngModel)]="model.data.generateCsv"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                        </wbo-textarea-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column [label]="'wbo.supplier.edit.field-set.primaryAddress'">
                        <wbo-address-edit [formGroupAddress]="editPage.formGroup.controls['address1']" [address]="model.data.address1"></wbo-address-edit>
                    </fui-column>
                    <fui-column [label]="'wbo.supplier.edit.field-set.secondaryAddress'">
                        <wbo-address-edit [formGroupAddress]="editPage.formGroup.controls['address2']" [address]="model.data.address2"></wbo-address-edit>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
